export default "<svg xmlns=\"http://www.w3.org/2000/svg\" id=\"mdi-stop\" viewBox=\"0 0 24 24\"><path d=\"M18,18H6V6H18V18Z\" fill=\"#fff\" /></svg>"